import React from "react";
import { useQuery } from "react-query";
import apiService from "services/api";
import { CustomTable } from "components";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { FiEdit, FiSearch } from "react-icons/fi";

const AddPointsRecordPage = () => {
	const { data: addPointsRecords, isLoading, refetch } = useQuery("addPointsRecords", () => apiService.points.get());
	const history = useHistory();

	const columns = [
		{
			id: "orderDate",
			Header: "Order Date",
			accessor: (row) => {
				return new Date(row.createdAt).toLocaleString();
			},
			sortable: true,
			filterable: true,
		},
		{
			id: "recordID",
			Header: "Record ID",
			accessor: "id",
			sortable: true,
			filterable: true,
		},
		{
			id: "user",
			Header: "Member Name",
			accessor: (row) => `${row.user.firstName} ${row.user.lastName}`,
			sortable: true,
			filterable: true,
		},
		{
			id: "pointsAdded",
			Header: "Points Added",
			accessor: "membershipPoints",
			sortable: true,
			filterable: true,
		},
		{
			id: "createdBy",
			Header: "Created By",
			accessor: (row) => row.createdBy.username,
			sortable: true,
			filterable: true,
		},
		{
			id: "uploaded",
			Header: "Uploaded Receipt",
			accessor: (row) => <div className={`${row.invoiceImgPath ? "text-success" : "text-danger"}`}>{row.invoiceImgPath ? "Yes" : "No"}</div>,
			sortable: true,
			filterable: true,
		},
		{
			id: "actions",
			Header: "actions",
			accessor: "actions",
			sortable: false,
			filterable: false,
		},
	];

	const actions = (row) => (
		<div className="actions-right">
			<Button onClick={() => history.push(`/coffee/add-points/${row.id}`)} color="warning" size="sm" className="btn-icon btn-link edit">
				<FiSearch />
			</Button>
			<Button onClick={() => history.push(`/coffee/add-points/edit/${row.id}`)} color="warning" size="sm" className="btn-icon btn-link edit">
				<FiEdit />
			</Button>
		</div>
	);

	return (
		<div className="content">
			{!isLoading && <CustomTable title="Add Point Records" data={addPointsRecords} refetch={refetch} columns={columns} actions={actions} csvName="add_points_record.csv" />}
		</div>
	);
};

export default AddPointsRecordPage;
